export default __webpack_public_path__ + "static/3-dc54cfc1479f51d5a98917500a85384a.gif";